import React, {useEffect, useMemo, useState} from "react";
import {css} from "@panda/css";

import {flexAbsoluteCenter, flexDirection, linkPseudoStateUnStyled, mb, ml, mt} from "@pg-design/helpers-css";
import {PhoneIcon} from "@pg-design/icons-module";
import {Link} from "@pg-design/link-module";
import {Loader} from "@pg-design/loader-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {phoneNumberFormat} from "@pg-mono/string-utils";

import {IOfferDetailApplication} from "../../offer/types/IOfferDetailApplication";
import {gtmRotatingPhoneNumbersCall} from "../../tracking/google_tag_manager/gtm_rotating_phone_numbers";
import {useClipPhoneNumber} from "../hooks/use_clip_phone_number";

interface IProps {
    isAutoresponderEnabled: boolean;
    showSeparatorText: boolean;
    isDataFetched: boolean;
    offer?: IOfferDetailApplication | null;
    propertyId?: number;
    optionalOfferPhoneData?: {
        configuration: {
            phone_clip: string | null;
        };
        is_phone_clip_enabled: boolean;
    };
}

const NO_CONTACT_DATA = "BRAK DANYCH KONTAKTOWYCH";

export const ApplicationPhoneNumber = (props: IProps) => {
    const [fetchInitialized, setFetchInitialized] = useState(false);

    const realPhoneNumber =
        (props.offer?.sales_offices.length && props.offer?.sales_offices[0].phone) ||
        (props.offer?.sales_offices.length && props.offer?.sales_offices[0].mobile);
    const fallbackPhoneNumber = useMemo(
        () =>
            (props.optionalOfferPhoneData?.is_phone_clip_enabled && props.optionalOfferPhoneData.configuration.phone_clip) ||
            (props.isDataFetched && props.offer?.is_phone_clip_enabled && props.offer?.configuration.phone_clip) ||
            (props.isDataFetched &&
                props.offer?.sales_offices &&
                props.offer?.sales_offices.length &&
                (props.offer.sales_offices[0].phone || props.offer.sales_offices[0].mobile)) ||
            null,
        [props.optionalOfferPhoneData, props.isDataFetched, props.offer]
    );
    const {phoneNumber: clipPhone, fetchClipPhoneNumber, isFetching, isClipPhoneBlocked} = useClipPhoneNumber(fallbackPhoneNumber);
    const phoneNumber = isClipPhoneBlocked ? realPhoneNumber : clipPhone;

    useEffect(() => {
        fetchClipPhoneNumber(props.propertyId);
        setFetchInitialized(true);
    }, []);

    return !props.isAutoresponderEnabled ? (
        <>
            {phoneNumber !== null && props.showSeparatorText && (
                <Text align="center" css={mt(2)} color={getThemeVariable("colors.gray.700")} variant="body_copy_2">
                    lub zadzwoń
                </Text>
            )}

            <div css={[flexAbsoluteCenter, mt(2)]}>
                {isFetching || !fetchInitialized ? (
                    <Loader size="sm" css={mt(2)} className={mutedLoader} />
                ) : phoneNumber ? (
                    <div css={[flexAbsoluteCenter, flexDirection("column")]}>
                        <div css={[flexAbsoluteCenter, mb(2)]}>
                            <PhoneIcon size="2.4" wrapperColor={getThemeVariable("colors.primary")} wrapperSize="4" />
                            <Link
                                css={[ml(2), linkPseudoStateUnStyled]}
                                href={`tel:+${phoneNumber}`}
                                onClick={() => {
                                    gtmRotatingPhoneNumbersCall();
                                }}
                            >
                                <Text as="span" variant="headline_6" color={getThemeVariable("colors.secondary")}>
                                    {phoneNumberFormat(phoneNumber)}
                                </Text>
                            </Link>
                        </div>
                    </div>
                ) : (
                    <Text as="span" variant="headline_6" align="center" color={getThemeVariable("colors.secondary")} css={mt(2)}>
                        {NO_CONTACT_DATA}
                    </Text>
                )}
            </div>
        </>
    ) : null;
};

const mutedLoader = css({
    opacity: 0.5
});
import React, {useEffect, useMemo, useState} from "react";
import {css} from "@panda/css";

import {flexAbsoluteCenter, flexDirection, linkPseudoStateUnStyled, mb, ml, mt} from "@pg-design/helpers-css";
import {PhoneIcon} from "@pg-design/icons-module";
import {Link} from "@pg-design/link-module";
import {Loader} from "@pg-design/loader-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {phoneNumberFormat} from "@pg-mono/string-utils";

import {IOfferDetailApplication} from "../../offer/types/IOfferDetailApplication";
import {gtmRotatingPhoneNumbersCall} from "../../tracking/google_tag_manager/gtm_rotating_phone_numbers";
import {useClipPhoneNumber} from "../hooks/use_clip_phone_number";

interface IProps {
    isAutoresponderEnabled: boolean;
    showSeparatorText: boolean;
    isDataFetched: boolean;
    offer?: IOfferDetailApplication | null;
    propertyId?: number;
    optionalOfferPhoneData?: {
        configuration: {
            phone_clip: string | null;
        };
        is_phone_clip_enabled: boolean;
    };
}

const NO_CONTACT_DATA = "BRAK DANYCH KONTAKTOWYCH";

export const ApplicationPhoneNumber = (props: IProps) => {
    const [fetchInitialized, setFetchInitialized] = useState(false);

    const realPhoneNumber =
        (props.offer?.sales_offices.length && props.offer?.sales_offices[0].phone) ||
        (props.offer?.sales_offices.length && props.offer?.sales_offices[0].mobile);
    const fallbackPhoneNumber = useMemo(
        () =>
            (props.optionalOfferPhoneData?.is_phone_clip_enabled && props.optionalOfferPhoneData.configuration.phone_clip) ||
            (props.isDataFetched && props.offer?.is_phone_clip_enabled && props.offer?.configuration.phone_clip) ||
            (props.isDataFetched &&
                props.offer?.sales_offices &&
                props.offer?.sales_offices.length &&
                (props.offer.sales_offices[0].phone || props.offer.sales_offices[0].mobile)) ||
            null,
        [props.optionalOfferPhoneData, props.isDataFetched, props.offer]
    );
    const {phoneNumber: clipPhone, fetchClipPhoneNumber, isFetching, isClipPhoneBlocked} = useClipPhoneNumber(fallbackPhoneNumber);
    const phoneNumber = isClipPhoneBlocked ? realPhoneNumber : clipPhone;

    useEffect(() => {
        fetchClipPhoneNumber(props.propertyId);
        setFetchInitialized(true);
    }, []);

    return !props.isAutoresponderEnabled ? (
        <>
            {phoneNumber !== null && props.showSeparatorText && (
                <Text align="center" css={mt(2)} color={getThemeVariable("colors.gray.700")} variant="body_copy_2">
                    lub zadzwoń
                </Text>
            )}

            <div css={[flexAbsoluteCenter, mt(2)]}>
                {isFetching || !fetchInitialized ? (
                    <Loader size="sm" css={mt(2)} className={mutedLoader} />
                ) : phoneNumber ? (
                    <div css={[flexAbsoluteCenter, flexDirection("column")]}>
                        <div css={[flexAbsoluteCenter, mb(2)]}>
                            <PhoneIcon size="2.4" wrapperColor={getThemeVariable("colors.primary")} wrapperSize="4" />
                            <Link
                                css={[ml(2), linkPseudoStateUnStyled]}
                                href={`tel:+${phoneNumber}`}
                                onClick={() => {
                                    gtmRotatingPhoneNumbersCall();
                                }}
                            >
                                <Text as="span" variant="headline_6" color={getThemeVariable("colors.secondary")}>
                                    {phoneNumberFormat(phoneNumber)}
                                </Text>
                            </Link>
                        </div>
                    </div>
                ) : (
                    <Text as="span" variant="headline_6" align="center" color={getThemeVariable("colors.secondary")} css={mt(2)}>
                        {NO_CONTACT_DATA}
                    </Text>
                )}
            </div>
        </>
    ) : null;
};

const mutedLoader = css({
    opacity: 0.5
});
